import React from 'react';
import { POKEMON_TYPES, TYPE_ABBREVIATIONS, TYPE_EFFECTIVENESS } from '../utils/pokemonTypes';
import './TypeEffectivenessChart.css';

function TypeEffectivenessChart({ selectedMoveType, selectedDefenderTypes }) {
  const getEffectiveness = (attackingType, defendingType) => {
    // Get the effectiveness value from the data, defaulting to 1 if not specified
    const effectiveness = TYPE_EFFECTIVENESS[attackingType]?.[defendingType];
    
    // Initialize the className
    let className = 'type-cell effectiveness';
    
    // Add appropriate class based on effectiveness
    if (effectiveness === 2) {
      className += ' super-effective';
    } else if (effectiveness === 0.5) {
      className += ' not-very-effective';
    } else if (effectiveness === 0) {
      className += ' immune';
    }

    // Generate description
    let description = '';
    if (effectiveness === 2) {
      description = `${attackingType}-type moves deal double damage to ${defendingType}-type Pokémon`;
    } else if (effectiveness === 0.5) {
      description = `${attackingType}-type moves deal half damage to ${defendingType}-type Pokémon`;
    } else if (effectiveness === 0) {
      description = `${defendingType}-type Pokémon are immune to ${attackingType}-type moves`;
    } else {
      description = `${attackingType}-type moves deal normal damage to ${defendingType}-type Pokémon`;
    }
    
    return { 
      value: effectiveness === undefined ? 1 : effectiveness, 
      className,
      description
    };
  };

  // Filter types to show based on selection
  const typesToShow = selectedMoveType ? [selectedMoveType] : POKEMON_TYPES;

  return (
    <div className="type-chart-container">
      <table className="type-grid">
        <thead>
          <tr>
            <th className="type-corner">Type</th>
            {POKEMON_TYPES.map((type) => (
              <th 
                key={type} 
                className={`type-cell type-${type.toLowerCase()}${selectedDefenderTypes?.includes(type) ? ' selected-type' : ''}`}
              >
                {TYPE_ABBREVIATIONS[type]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {typesToShow.map((attackingType) => (
            <tr key={attackingType} className={selectedMoveType ? 'single-row' : ''}>
              <td 
                className={`type-cell type-${attackingType.toLowerCase()}${selectedMoveType === attackingType ? ' selected-type' : ''}`}
              >
                {attackingType}
              </td>
              {POKEMON_TYPES.map((defendingType) => {
                const { value, className, description } = getEffectiveness(attackingType, defendingType);
                const isHighlighted = selectedMoveType === attackingType || selectedDefenderTypes?.includes(defendingType);
                const isIntersection = selectedMoveType === attackingType && selectedDefenderTypes?.includes(defendingType);
                return (
                  <td
                    key={`${attackingType}-${defendingType}`}
                    className={`${className}${isHighlighted ? ' highlighted-cell' : ''}${isIntersection ? ' intersection-cell' : ''}`}
                    data-description={description}
                  >
                    {value === 1 ? '×1' : value === 2 ? '×2' : value === 0.5 ? '×½' : '×0'}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TypeEffectivenessChart; 